import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const countries = new Vuex.Store({
  state: {
    contries: {},
    timezones: {},
    contriesUploded: false,
    timezonesUploded: false

  },
  mutations: {
    setCountris (state, contries) {
      state.contries = contries
    },

    setTimezones (state, timezones) {
      const timezonesArray = Object.entries(timezones).map(([key, value]) => ({
        id: key, // Se vuoi mantenere la chiave UUID originale
        ...value // Copia tutte le proprietà interne (uid, name, time_format)
      }))

      timezonesArray.sort((a, b) => {
        const nameA = a.name.toUpperCase() // Ignora maiuscole/minuscole
        const nameB = b.name.toUpperCase() // Ignora maiuscole/minuscole

        if (nameA < nameB) {
          return -1 // a viene prima di b
        }
        if (nameA > nameB) {
          return 1 // a viene dopo b
        }
        return 0 // i nomi sono uguali
      })

      timezonesArray.forEach(item => {
        // Se hai usato Object.values(), qui dovresti decidere quale chiave usare (es. item.uid)
        // Se hai usato Object.entries().map(([key, value]) => ({ id: key, ...value })),
        // puoi usare item.id come chiave.
        state.timezones[item.id] = { uid: item.uid, name: item.name, time_format: item.time_format }
      })
    },
    setContriesUploded (state) {
      state.contriesUploded = true
    },
    setTimezoneUploded (state) {
      state.timezonesUploded = true
    }

  },
  actions: {
    caricaNazioni ({ commit }, json) {
      const tmpTime = {}

      json.forEach(c => {
        tmpTime[c.uid] = c.timezone
      })

      commit('setTimezones', tmpTime)
      commit('setTimezoneUploded')

      commit('setCountris', json)
      commit('setContriesUploded')
    },
    caricaTimezones ({ commit }, json) {
      commit('setTimezones', json)
      commit('setTimezoneUploded')
    }

  },
  getters: {
    countrisUploded: (state) => state.contriesUploded,
    timezonesUploded: (state) => state.timezonesUploded,
    contries: (state) => state.contries,
    timezones: (state) => state.timezones

  },
  plugins: [
    createPersistedState({
      key: 'countryStore',
      // Scegli dove persistere lo stato
      storage: window.localStorage, // Questo è il default, ma è buona pratica specificarlo
      // Quali proprietà di primo livello dello stato vuoi persistere
      paths: [
        'contries', // Persisti l'oggetto userinfo
        'timezones',
        'contriesUploded',
        'timezonesUploded'
      ]

    })
  ]
})

export default countries
